/**
 * https://github.kakaocorp.com/kakaopage/api/blob/feature/8.0.0/develop/api/src/main/java/com/kakaopage/api/model/search/SearchSeriesResult.java#L12
 */
export enum SearchKeywordSortTypeVo {
  /** default: LATEST */
  Latest = 'LATEST',
  Accuracy = 'ACCURACY',
}
